module.exports = __webpack_public_path__ + "img/hcml_main2.fd8505e0.jpg";